import { Translation } from './translation';

export const en_fr: Partial<Translation> = {
  common: {
    currency: {
      short: 'EUR',
      price: `{price} €`,
      pricePerMonth: `{price} € / month`,
      pricePerSquareMeter: `{price} €/m<sup>2</sup>`,
    },
  },
  filters: {
    search: {
      label: 'City, region, postcode, object ID, ...',
    },
  },
  regionSearch: {
    state: 'Region',
    county: 'Department',
    suburb: 'Arrondissement',
  },
  searchSubscription: {
    search: {
      label: 'City, region, postcode, ...',
    },
  },
  realEstateObject: {
    reserved: 'Under offer',
    topOffer: 'Exclusivity',
  },
};
